module.exports = __webpack_public_path__ + "static/media/gp2.77f8de9f.webp";